// frontend/src/api/stores.js
import { apiClient } from './index';

const storesApi = {
  /**
   * Get public details for a store (Storefront)
   */
  getPublicDetails: async (storeId) => {
    return await apiClient.get(`/stores/public/${storeId}`);
  },

  /**
   * Get all stores (Admin only)
   */
  getAllStores: async () => {
    return await apiClient.get('/stores/');
  },

  /**
   * Get stores owned by the current user
   */
  getMyStores: async () => {
    return await apiClient.get('/stores/mine');
  },

  /**
   * Create a new store (Admin only)
   * @param {Object} storeData 
   */
  createStore: async (storeData) => {
    return await apiClient.post('/stores/', storeData);
  },

  /**
   * Update an existing store (Admin only)
   * @param {string} storeId 
   * @param {Object} updateData 
   */
  updateStore: async (storeId, updateData) => {
    return await apiClient.put(`/stores/${storeId}`, updateData);
  },

  /**
   * Delete a store (Admin only)
   * @param {string} storeId 
   */
  deleteStore: async (storeId) => {
    return await apiClient.delete(`/stores/${storeId}`);
  }
};

export { storesApi };